import { Vocabulary } from "../../../Utils/Vocabulary";
import { EComponentTypes } from "../../../Utils/Enums";
import { formatMinutesToHours } from "../../../Utils/Utils";

export const instructorTimesheetColumns: any[] = [
  {
    name: "productName",
    label: Vocabulary.product,
    options: {
      setCellProps: () => ({
        style: {
          position: "sticky",
          left: 0,
          background: "#fff",
          zIndex: 1000,
        },
      }),
    },
  },
  {
    name: "drivingHours",
    label: Vocabulary.drivingHours,
    options: {
      customBodyRender: (value: any) => {
        return value ? formatMinutesToHours(value) : 0;
      },
      exportValue: (value: any) => value ? formatMinutesToHours(value) : 0,
    },
  },
  {
    name: "supplementaryHours",
    label: Vocabulary.supplementaryHours,
  },
  {
    name: "examHours",
    label: Vocabulary.examHours,
    options: {
      customBodyRender: (value: any) => {
        return value ? formatMinutesToHours(value) : 0;
      },
      exportValue: (value: any) => value ? formatMinutesToHours(value) : 0,
    },
  },
];

/**
 * additional filters for the instructor timesheet report
 */
export const instructorsTimesheetFilters = (instructors: any[]) => [
  {
    property: "instructorId",
    autocompleteFilterProperty: "instructorId",
    label: Vocabulary.instructor,
    type: EComponentTypes.AUTOCOMPLETE,
    validation: null,
    defaultValue: instructors[0]?.instructorId,
    options: instructors,
    otherOptions: { disableClearable: true },
  },
];
